import { render } from "./parking.vue?vue&type=template&id=72f2bf56"
import script from "./parking.vue?vue&type=script&lang=js"
export * from "./parking.vue?vue&type=script&lang=js"

import "./parking.vue?vue&type=style&index=0&id=72f2bf56&lang=less"

import exportComponent from "/Users/alex/Documents/Google Ads/Panorama Residence/Panorama web/panorama-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__